<div class="dialog-container" >

    <div class="close-icon">
       <div class="close add-close-button" data-dismiss="modal" (click)="closeDialog()">
          <span class="material-icons close-icon-web">clear</span>
        </div>
    </div>

    <div class="web-close-icon">
        <button 
                matTooltipPosition="above"
                data-dismiss="modal" (click)="closeDialog()" class="web-close-btn">
          <span class="material-icons " style="position: relative;">clear</span>
        </button>
      </div>

    <div class="security-key-wrapper">
        <div class="security-img-container">
            <img src="../../../../../../../assets/images/security-key-green.svg" class="security-key-img"/>
        </div>

        <div class="security-text-container">
            <h2 class="security-text-main">This Folder contains Encrypted Files</h2>
            <div class="security-subtext-container">
                <h2 class="security-sub-text" >This folder contains file(s) protected by a security key. Anyone you share it with will need your key in order to access the protected file(s). </h2>
            </div>
        </div>
    </div>
</div>
